import React from 'react';
import PropTypes from 'prop-types';
import { I18n, translate } from '@td/shared_utils';

export const MANAGED_DRUG_LISTS_TRANSLATION_KEYS = {
  GENERAL: 'general_medical',
  BH_DOC: 'mental_health',
  DERM: 'dermatology',
  P360: 'primary_care',
};

const ManagedMedicationsTableRow = ({ medication }) => (
  <tr>
    <td>{medication.drugId}</td>
    <td>{medication.drugName}</td>
    <td>
      {medication.managedDrugLists
        .map(drugList =>
          translate(
            null,
            'medication_formularies.table.managed_drug_lists',
            MANAGED_DRUG_LISTS_TRANSLATION_KEYS[drugList.name]
          )
        )
        .join(' / ')}
    </td>
    <td>
      <a href={`/medication_formularies/${medication.drugId}`}>
        <I18n scope="medication_formularies.table.actions" text="manage" />
      </a>
    </td>
  </tr>
);

ManagedMedicationsTableRow.propTypes = {
  medication: PropTypes.shape({
    drugId: PropTypes.string,
    drugName: PropTypes.string,
    managedDrugLists: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string
      })
    )
  })
};

export default ManagedMedicationsTableRow;
